/* @flow */
import * as React from 'react'

const ResponsiveImage = ({ src, alt = '' }: { alt?: string, src: string }) => (
    <img className="responsiveImage" alt={alt} src={src} style={{ display: 'block', width: '100%' }} />
)

export default ResponsiveImage
